<form
  [formGroup]="form"
  (ngSubmit)="confirm()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <h1 class="text-[18px] font-black">
        <i
          class="pi pi-file-plus"
          style="font-size: 2rem"></i>
        DAR DE ALTA UN USO DE SOLUCIÓN IA
      </h1>

      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Guardar'"
          [disabled]="form.invalid || !hasAiSolutionSelection()"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4 gap-2">
      <span class="text-2xl font-bold">Datos del uso de solución IA</span>
      <!-- <span class="text-[16px] font-normal text-neutral-dark">Escribe los datos del uso de solución IA</span> -->
      <span class="text-[16px] text-neutral-dark py-1">
        Todos los campos marcados con un asterisco (*) son obligatorios.
      </span>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
      <div class="flex flex-col">
        <label
          class="text-[16px]"
          for="ai-solution-type">
          Tipo*
        </label>
        <span class="text-[16px] text-neutral-dark">Indica la categoría a la que pertenece la solución IA</span>
        <desy-select
          id="ai-solution-type"
          formControlName="aiSolutionType"
          classes="min-w-full mt-2">
          <!-- <desy-label>Selecciona un tipo</desy-label> -->
          <desy-option
            value=""
            [disabled]="true"
            [hidden]="true"
            [selected]="true">
            Selecciona un tipo
          </desy-option>
          <desy-option
            *ngFor="let type of aiSolutionTypeOptions"
            [id]="type.value.toString()"
            [value]="type.value">
            {{ type.label }}
          </desy-option>
        </desy-select>
        <desy-error-message *ngIf="getError(form, 'aiSolutionType', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>
      </div>

      <div class="flex flex-col md:pt-6">
        <label
          class="text-[16px]"
          for="solution-usage-id">
          Identificador del registro*
        </label>
        <!-- <span class="text-[16px] text-neutral-dark">Escribe un título breve que identifique esta solicitud</span> -->
        <desy-input
          id="solution-usage-id"
          formControlName="solutionUsageName"
          placeholder="Escribe un título breve que identifique esta solicitud"
          classes="w-full text-[16px] mt-2"
          class="w-full"
          [maxlength]="500"></desy-input>
        <desy-error-message *ngIf="getError(form, 'solutionUsageName', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>
      </div>
    </div>

    <div class="flex flex-col gap-6 py-4">
      <span class="text-[18px] font-bold">Datos identificativos del uso de solución IA</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="requesting-person">
            Persona solicitante*
          </label>
          <desy-input
            id="requesting-person"
            classes="w-full"
            formControlName="requestingPerson"
            placeholder="Búsqueda por nombre, apellidos, código o puesto"></desy-input>
          <desy-error-message *ngIf="getError(form, 'requestingPerson', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="contact-email">
            Correo de contacto*
          </label>
          <desy-input
            id="contact-email"
            classes="w-full"
            formControlName="requestingPersonEmail"></desy-input>
          <desy-error-message *ngIf="getError(form, 'requestingPersonEmail', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="requesting-org">
            Unidad Organizativa Solicitante*
          </label>
          <desy-input
            id="requesting-org"
            classes="w-full"
            placeholder="Unidad Organizativa Solicitante"
            formControlName="requestingOrg"></desy-input>
          <desy-error-message *ngIf="getError(form, 'requestingOrg', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="department">
            Departamento solicitante*
          </label>
          <desy-input
            id="department"
            classes="w-full"
            placeholder="Departamento solicitante"
            formControlName="department"></desy-input>
          <desy-error-message *ngIf="getError(form, 'department', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6 py-6">
      <span class="text-[18px] font-bold">Datos funcionales del uso de solución IA</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="solution-usage-name-field flex flex-col">
          <label
            class="text-[16px]"
            for="solution-usage-name">
            Nombre*
          </label>
          <span class="text-[16px] text-neutral-dark mb-2">Selecciona una solución existente o añade una nueva.</span>
          <app-ai-solution-search
            id="solution-usage-name"
            formControlName="solutionName"
            (selectionChange)="onAiSolutionSelectionChanged($event)" />
          <desy-error-message *ngIf="getError(form, 'solutionName', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div
          *ngIf="hasAiSolutionSelection()"
          class="flex flex-col md:col-span-2">
          <label
            class="text-[16px]"
            for="ai-solution-description">
            Finalidad*
          </label>
          <span class="text-[16px] text-neutral-dark">Explica brevemente la finalidad de la solucion IA</span>
          <desy-textarea
            id="ai-solution-description"
            formControlName="aiSolutionDescription"
            placeholder="Ej. Cursor es una solución IA que permite generar consultas y estructuras de base de datos a partir de lenguaje natural"
            classes="w-full text-[16px]"
            class="w-full"
            [rows]="5"
            [maxlength]="500"></desy-textarea>
          <desy-error-message *ngIf="getError(form, 'aiSolutionDescription', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col md:col-span-2">
          <label
            class="text-[16px]"
            for="expected-use">
            Uso previsto*
          </label>
          <span class="text-[16px] text-neutral-dark">Describe el uso previsto de la solución IA</span>
          <desy-textarea
            id="expected-use"
            formControlName="expectedUse"
            placeholder="Ej: Acelerar la creación y optimización de bases de datos generando esquemas, tablas, relaciones, índices y documentación técnica de forma automática."
            classes="w-full text-[16px]"
            class="w-full"
            [rows]="5"
            [maxlength]="500"></desy-textarea>
          <desy-error-message *ngIf="getError(form, 'expectedUse', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>
  </div>
</form>
<p-confirmdialog />
